/**
 * The third-party delivery client seam.
 *
 * Components and hooks depend ONLY on this interface. The live implementation
 * is the Hasura-backed client (hasuraClient.ts):
 *   quote()           → partsDeliveryQuote Hasura action (services/parts fans
 *                       out to the real vendors)
 *   book()            → insert_parts_deliveries_one (requested_vendor pins the
 *                       quoted vendor; the db-parts-deliveries trigger books)
 *   getStatusForRun() → mobility_runs.parts_delivery relationship poll
 */

import type { TpBookRequest, TpDeliveryState, TpQuoteRequest, TpQuoteResult } from './types';
import { hasuraClient } from './hasuraClient';

export interface ThirdPartyDeliveryClient {
  /** Shop per-vendor quotes for one pickup → one dropoff. */
  quote(req: TpQuoteRequest): Promise<TpQuoteResult>;
  /** Book the delivery with the chosen vendor. */
  book(req: TpBookRequest): Promise<{ parts_delivery_id: string }>;
  /** Live delivery state for a shell run (null when none exists). */
  getStatusForRun(runId: number): Promise<TpDeliveryState | null>;
  /** Cancel a booked delivery at the vendor (partsDeliveryCancel action).
   * Rejects with the backend's message when the vendor refuses or the row is
   * still booking ("try again in a minute" flows to the caller verbatim). */
  cancel(partsDeliveryId: number, reason?: string): Promise<{ delivery_status: string }>;
}

export const getThirdPartyClient = (): ThirdPartyDeliveryClient => hasuraClient;
